import { createRouter, createWebHashHistory } from "vue-router";
import { localCache } from "@/utils/Cache";
import { getParams } from "@/utils/getParams";
import { codeLogin, getUserinfo } from "@/common/api/http.api.login";
import { Dialog } from "vant";

const routes = [
  {
    path: "/",
    redirect: "/home",
  },
  {
    path: "/error",
    name: "error",
    component: () => import("@/views/error"),
  },
  {
    path: "/loading",
    name: "loading",
    component: () => import("@/views/loading"),
  },
  {
    path: "/noperssion",
    name: "noperssion",
    component: () => import("@/views/noperssion"),
  },
  // 登录
  {
    path: "/login",
    name: "login",
    component: () => import("../views/login"),
  },
  // 首页
  {
    path: "/home",
    name: "home",
    component: () => import("../views/Home"),
  },
  // 修改密码
  {
    path: "/modifyPassword",
    name: "modifyPassword",
    component: () =>
      import("../views/personalCenter/modifyPassword/modifyPassword"),
  },
  // 个人中心
  {
    path: "/personalCenter",
    name: "personalCenter",
    component: () => import("../views/personalCenter/personalCenter"),
  },
  // 我的抄送 会议
  {
    path: "/myCCMeeting",
    name: "myCCMeeting",
    component: () => import("../views/personalCenter/myCCMeeting/myCCMeeting"),
  },
  // 我的抄送 活动
  {
    path: "/myCCActivity",
    name: "myCCActivity",
    component: () => import("../views/personalCenter/myCCActivity/myCCActivity"),
  },
  // 预约说明
  {
    path: "/bookExplain",
    name: "bookExplain",
    component: () => import("../views/personalCenter/bookExplain/bookExplain"),
  },
  // 会议预约
  {
    path: "/meetingReservation",
    name: "meetingReservation",
    component: () => import("../views/meetingReservation/meetingReservation"),
  },
  // 现有预约
  {
    path: "/currentAppointments",
    name: "currentAppointments",
    component: () => import("../views/currentAppointments/currentAppointments"),
  },
  // 预约审核
  {
    path: "/appointmentReview",
    name: "appointmentReview",
    component: () => import("../views/appointmentReview/appointmentReview"),
  },
  // 预约审核 详情
  {
    path: "/appointmentReviewDetails",
    name: "appointmentReviewDetails",
    component: () =>
      import("../views/appointmentReview/appointmentReviewDetails"),
  },
  // 会议预约信息
  {
    path: "/appointmentInformation",
    name: "appointmentInformation",
    component: () =>
      import("../views/meetingReservation/appointmentInformation"),
  },
  // 会议预约记录
  {
    path: "/meetingRecord",
    name: "meetingRecord",
    component: () =>
      import("../views/personalCenter/meetingRecord/meetingRecord"),
  },
  // 我参与的会议预约记录
  {
    path: "/myJoinMeetingRecord",
    name: "myJoinMeetingRecord",
    component: () =>
      import("../views/personalCenter/myJoinMeetingRecord/myJoinMeetingRecord"),
  },
  // 会议预约记录 详情
  {
    path: "/meetingDetail",
    name: "meetingDetail",
    component: () =>
      import("../views/personalCenter/meetingRecord/meetingDetail"),
  },
  // 会议预约记录 排座
  {
    path: "/seatArrangement",
    name: "seatArrangement",
    component: () =>
      import("../views/personalCenter/meetingRecord/seatArrangement"),
  },
  // 活动预约
  {
    path: "/eventReservation",
    name: "eventReservation",
    component: () => import("../views/eventReservation/eventReservation"),
  },
  // 参加活动
  {
    path: "/joinActivities",
    name: "joinActivities",
    component: () => import("../views/joinActivities/joinActivities"),
  },
  // 参加活动 活动座位预约信息
  {
    path: "/activityInformation",
    name: "activityInformation",
    component: () => import("../views/joinActivities/activityInformation"),
  },
  // 活动预约信息
  {
    path: "/activitiesAppointmentInformation",
    name: "activitiesAppointmentInformation",
    component: () => import("../views/eventReservation/appointmentInformation"),
  },
  // 活动预约记录
  {
    path: "/activityRecord",
    name: "activityRecord",
    component: () =>
      import("../views/personalCenter/activityRecord/activityRecord"),
  },
  // 活动预约记录 详情
  {
    path: "/activityDetail",
    name: "activityDetail",
    component: () =>
      import("../views/personalCenter/activityRecord/activityDetail"),
  },
  // 发布任务 任务列表
  {
    path: "/taskList",
    name: "taskList",
    component: () => import("../views/publishTask/taskList"),
  },
  // 发布任务 发布任务列表
  {
    path: "/publishTaskList",
    name: "publishTaskList",
    component: () => import("../views/publishTask/publishTaskList"),
  },
  // 发布任务
  {
    path: "/publishTask",
    name: "publishTask",
    component: () => import("../views/publishTask/publishTask"),
  },
  // 我的任务 列表
  {
    path: "/myTaskList",
    name: "myTaskList",
    component: () => import("../views/myTask/myTaskList"),
  },
  // 扫码签到
  {
    path: "/signQRCode",
    name: "signQRCode",
    component: () => import("../views/sign/signQRCode"),
  },
  // 签到详情
  {
    path: "/signDetail",
    name: "signDetail",
    component: () => import("../views/sign/signSeatArrangement.vue"),
  },
  // 签离
  {
    path: "/signOutQRCode",
    name: "signOutQRCode",
    component: () => import("../views/sign/signOutQRCode"),
  },
  // 签离详情
  {
    path: "/signOutDetail",
    name: "signOutDetail",
    component: () => import("../views/sign/signOutSeatArrangement.vue"),
  },
  // 扫码签到
  {
    path: "/signQRCodeTest",
    name: "signQRCodeTest",
    component: () => import("../views/sign/signQRCode1"),
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});
router.beforeEach((to, from, next) => {
  let token = localCache.getCache("venueMoibleToken");
  let codeValue = getParams(window.location.href.split("?")[1])?.code;
  if (codeValue) {
    codeLogin({
      code: codeValue,
    }).then((res) => {
      let url = getNewUrl();
      window.history.replaceState(null, null, url);
      localCache.setCache("venueMoibleToken", res.data?.access_token);
      loadUserinfo(res.data?.access_token);
    });
  } else {
    if (token) {
      next();
    } else {
    }
  }

  function loadUserinfo(access_token) {
    getUserinfo({
      accessToken: access_token,
    })
      .then((res) => {
        localCache.setCache(
          "permissionList",
          JSON.stringify(res.data.permissionList)
        );
        localCache.setCache("roleList", JSON.stringify(res.data.roleList));
        localCache.setCache("userData", JSON.stringify(res.data.userInfo));
        localCache.setCache("venueMoibleToken", res.data?.token);
        if (res.data.needResetPassword) {
          Dialog.confirm({
            title: "系统提示",
            message: "为您的账号安全，请及时修改初始密码",
            confirmButtonText: "去修改",
            showCancelButton: true,
            cancelButtonText: "关闭",
          })
            .then(() => {
              router.push({
                name: "modifyPassword",
                state: {
                  params: {
                    password: "123456",
                  },
                },
              });
            })
            .catch(() => {});
        }
        if (window.location.href?.indexOf("/joinActivities") > -1) {
          // 从服务大厅首页 活动报名中跳转
          let routeList = router.options.routes[0];
          routeList.redirect = "/joinActivities";
          next(routeList.redirect);
        } else {
          next();
        }
      })
      .catch(() => {});
  }

  // 清除浏览器携带的参数
  function getNewUrl() {
    let url = document.location.href;
    let reg = /[^\w](code)=?([^&|^#]*)/g;
    url = url.replace(reg, "");
    reg = /&&/g;
    url = url.replace(reg, "");
    reg = /&#/g;
    url = url.replace(reg, "#");
    reg = /\?#/g;
    url = url.replace(reg, "#");
    reg = /\?#/g;
    url = url.replace(reg, "#");
    return url;
  }
});
export default router;
